import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Pill } from '@resy/ui-kitchen';
import '../ReservationQuestionnaire.scss';

const AllergyButtonGroup = ({
  allergyTags,
  dietaryTags,
  disabled,
  saveAllergy,
  savedTags,
}) => (
  <>
    <div className="allergy-button-group">
      {allergyTags.map((allergy) => (
        <Pill
          item={{
            isDisabled: disabled,
            isSelected: !!savedTags[allergy.id],
            labelText: allergy.name,
          }}
          className={cx('allergy-button-group__input', { 'allergy-button-group__input--active': savedTags[allergy.id] })}
          onClick={/* istanbul ignore next */ () => saveAllergy(allergy)}
          key={allergy.name}
        />
      ))}
    </div>

    <div className="allergy-button-group">
      {dietaryTags.map((diet) => (
        <Pill
          item={{
            isDisabled: disabled,
            isSelected: !!savedTags[diet.id],
            labelText: diet.name,
          }}
          className={cx('allergy-button-group__input', { 'allergy-button-group__input--active': savedTags[diet.id] })}
          onClick={/* istanbul ignore next */ () => saveAllergy(diet)}
          key={diet.name}
        />
      ))}
    </div>
  </>
);

AllergyButtonGroup.propTypes = {
  allergyTags: PropTypes.arrayOf(PropTypes.shape({
    group_id: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    category_id: PropTypes.number.isRequired,
    type_ids: PropTypes.arrayOf(PropTypes.number).isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  dietaryTags: PropTypes.arrayOf(PropTypes.shape({
    group_id: PropTypes.number.isRequired,
    id: PropTypes.number.isRequired,
    category_id: PropTypes.number.isRequired,
    type_ids: PropTypes.arrayOf(PropTypes.number).isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  disabled: PropTypes.bool,
  saveAllergy: PropTypes.func.isRequired,
  savedTags: PropTypes.shape({
    [PropTypes.number]: PropTypes.string,
  }).isRequired,
};

AllergyButtonGroup.defaultProps = {
  disabled: false,
};

export default AllergyButtonGroup;
